import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { getGoogleMerchantSettings, updateGoogleMerchantSettings } from './actionCreators';
import { SLICE_NAME, IGoogleMerchantSettingsState, initialState } from './models';

export const googleMerchantSettingsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGoogleMerchantSettings.fulfilled, (state: IGoogleMerchantSettingsState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.data = payload;
      })
      .addCase(updateGoogleMerchantSettings.fulfilled, (state: IGoogleMerchantSettingsState, action) => {
        const { payload } = action;
        state.isLoading = false;
        if (state?.data) state.data = { ...state.data, ...payload };
      })
      .addMatcher(
        isPending(getGoogleMerchantSettings, updateGoogleMerchantSettings),
        (state: IGoogleMerchantSettingsState) => {
          state.isLoading = true;
          state.error = null;
        },
      )
      .addMatcher(
        isRejected(getGoogleMerchantSettings, updateGoogleMerchantSettings),
        (state: IGoogleMerchantSettingsState, action) => {
          const { error } = action;
          state.isLoading = false;
          state.error = error;
          showApiErrors(error);
        },
      );
  },
});
